import { FC, MouseEvent, useEffect, useState } from 'react';

import { IconEdit } from '@assets';

import * as S from './styled';

// Stop clicks inside the edit UI from bubbling to the cell's navigate handler.
const stopClick = (e: MouseEvent) => e.stopPropagation();

export const NameCell: FC<{
  id: string;
  name?: string;
  hasAmount?: boolean;
  onRename: (id: string, name: string) => void;
}> = ({ id, name, hasAmount, onRename }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(name ?? '');

  useEffect(() => {
    setValue(name ?? '');
  }, [name]);

  const commit = () => {
    setIsEditing(false);
    const next = value.trim();
    if (next && next !== name) {
      onRename(id, next);
    } else {
      setValue(name ?? '');
    }
  };

  if (isEditing) {
    return (
      <S.DocumentNameWrapper align="center" onClick={stopClick}>
        <S.NameInput
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={commit}
          onPressEnter={commit}
        />
      </S.DocumentNameWrapper>
    );
  }

  return (
    <S.DocumentNameWrapper align="center">
      {hasAmount && <S.Point />}
      <S.DocumentName>{value || 'No name'}</S.DocumentName>
      <S.EditIcon
        role="button"
        tabIndex={0}
        aria-label="Rename document"
        onClick={(e) => {
          stopClick(e);
          setIsEditing(true);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            setIsEditing(true);
          }
        }}
      >
        <IconEdit width={14} height={14} />
      </S.EditIcon>
    </S.DocumentNameWrapper>
  );
};
